// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609080504/js/" + chunkId + "." + {"44":"56c37e46","225":"7340c06a","481":"2f9c21c8","486":"cb742e35","770":"5c0df1ed"}[chunkId] + ".0.7290193416355343.chunk.js";
};